import type { UserWithMeta } from '~/@biz_account/useUser/types'

function getContactInfoItems(userProfile: UserWithMeta['profile'] | undefined) {
  if (userProfile == null) return []

  return [
    {
      label: 'Tel. číslo:',
      value: (userProfile.phone ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0'),
    },
    { label: 'Email:', value: userProfile.email },
  ]
}

export { getContactInfoItems }
